import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as GreenTick } from "../../assets/images/green_tick.svg";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { Offcanvas } from "react-bootstrap";
import * as apicall from "../../components/Apicall";
import CurrencyDropdown from "./CurrencyDropdown";
import NewAppointment from "../../components/Appointment/NewAppointment";

const Setup = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = React.useState(0);
  const [completedSteps, setCompletedSteps] = useState({
    profile: false,
    service: false,
    type: false,
    crew: false,
    order: false,
  });
    const [profileData, setProfileData] = useState("");

  
  // let allServices = localStorage.getItem("userDetails");
  // if (allServices && allServices !== "undefined") {
  //   allServices = JSON.parse(allServices);
  // }
  const isClinicService = Number(profileData?.industry) === 1;
  useEffect(() => {
    fetchProgress();
    // Re-fetch when the tab becomes visible again (user navigates back)
    const onVisible = () => { if (document.visibilityState === "visible") fetchProgress(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);
  const [showAppointment, setShowAppointment] = useState(false);

  const handleStepClick = (step) => {
    if (step.status === "order") {
      if (isClinicService) {
        setShowAppointment(true);
      } else {
        navigate("/vendor_bookings");
      }
    } else {
      navigate(step.navigate);
    }
  };
  async function fetchProgress() {
    try {
      setLoading(true);
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking,
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_offerings`),
        apicall.get(`get_ezp_service_providers`),
        apicall.get(`get_ezp_booking?page=1&limit=1`),
      ]);
      console.log(
        ezpMyProfile?.data,
        services_api?.data,
        service_type_api?.data,
        get_ezp_service_providers?.data,
        get_ezp_booking?.data,
        "completedData-----"
      );
      setProfileData(ezpMyProfile?.data?.[0] || {});
      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0,
      };
      setUserName(ezpMyProfile?.data?.[0]?.first_name || "");
      let totalPercentage = Object.values(ans).filter((val) => val).length * 20;
      console.log("ans--", ans, totalPercentage);
      setProgress(totalPercentage);
      setCompletedSteps(ans);
      localStorage.setItem(
        "setupCompleted",
        totalPercentage === 100 ? "true" : "false"
      );
      setLoading(false);
    } catch (e) {
      console.log("Error fetching progress: ", e);
      setLoading(false);
    }
  }

  async function next() {}

  let allSteps = [
    {
      title: "Complete Profile",
      description: "Add your business details to get started.",
      navigate: "/vendors/view-profile",
      status: "profile",
    },
    {
      title: "Service Creation",
      description: "Create and organize the services you offer.",
      navigate: "/admin-setup?tab=categories",
      status: "service",
    },
    {
      title: "Service Type Creation",
      description: "Define service variations like 1BHK, 2BHK, etc.",
      navigate: "/admin-setup?tab=service-types",
      status: "type",
    },
    {
      title: "Crew Creation",
      description: "Add team members and assign their roles.",
      navigate: "/admin-setup?tab=providers",
      status: "crew",
    },
    {
      title: "Order Booking",
      description: "Schedule and manage customer appointments.",
      status: "order",
    },
  ];

  const navigateToPage = (ele) => {
    try {
      console.log("ele?.navigate--", ele?.navigate);
      navigate(ele?.navigate);
    } catch (e) {
      console.log("Error navigating to page: ", e);
    }
  };

  async function boxCLick(ele, index) {
    try {
      if (Object.values(completedSteps)[index - 1]) {
        navigateToPage(ele);
      } else {
        if (index === 0) navigateToPage(ele);
        next();
      }
    } catch (e) {
      console.log("err----", e);
    }
  }

  return (
    <>
    <div className="flex-center setup-container">
      <div className="inner-setup-container">
        <div className="w-100">
          <div style={{ textAlign: "center", marginBottom: "0.5rem" }}>
            {loading ? "Loading...." : `Let's get you setup, ${userName}!`}
          </div>
          <div className="setupBox">
            <div className="d-flex justify-between align-center mb-3 w-100">
              <div>Geting Started</div>
              <div>{progress / 20}/5 completed</div>
            </div>
            <div style={styles.container}>
              <div
                style={{
                  ...styles.filler,
                  width: `${progress}%`,
                }}
              >
                <span className="progress-label" style={styles.label}>
                  {progress}%
                </span>
              </div>
            </div>
            <div style={{ marginTop: "1rem" }}>
              {allSteps.map((ele, index) => (
                <div
                  onClick={() => {
                    if (ele.status === "order") {
                      handleStepClick(ele);
                    } else {
                      boxCLick(ele, index);
                    }
                  }}
                  className={[
                    "eachSetup",
                    completedSteps[ele?.status] && "completedBOX",
                    !Object.values(completedSteps)[index - 1] && "opacityBOX",
                    index === 0 && "opacityFull",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  key={index}
                >
                  <div className="d-flex gap-4">
                    <div style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                      {index + 1}
                    </div>
                    <div className="flex-col gap-2">
                      <div>{ele?.title}</div>
                      <div style={{ fontSize: "0.9rem" }}>
                        {ele?.description}
                      </div>
                    </div>
                  </div>
                  <div>
                    {completedSteps[ele?.status] ? (
                      <GreenTick className="greenTick" />
                    ) : (
                      <div className="rightArrow">
                        <FaArrowRight />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="setupBox" style={{ marginTop: "5px" }}>
            <div style={{ color: "#d01c4c" }}>
              We’ll help you get started with setup for free—contact us by phone
              or email our sales team.
              <br />
              UAE: +971 56 130 3601 ; Email: sales@ezeitpro.com
            </div>
          </div>
        </div>
      </div>
    </div>

    <Offcanvas
      show={showAppointment}
      onHide={() => setShowAppointment(false)}
      placement="end"
      backdrop={true}
      style={{ width: "500px", minWidth: "500px", maxWidth: "500px", flexShrink: 0 }}
    >
      <Offcanvas.Header closeButton className="custom-border-bottom p-4">
        <Offcanvas.Title className="page-heading">New Appointment</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0 d-flex flex-column">
        <div className="appointment-card">
          <div className="appointment-body">
            {showAppointment && (
              <NewAppointment
                onClose={() => {
                  setShowAppointment(false);
                  fetchProgress();
                }}
                mode="new"
              />
            )}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
    </>
  );
};

export default Setup;
const styles = {
  container: {
    height: "20px",
    width: "100%",
    backgroundColor: "#e0e0df",
    borderRadius: "10px",
  },
  filler: {
    height: "100%",
    backgroundColor: "#38A60D",
    borderRadius: "inherit",
    textAlign: "right",
    transition: "width 0.4s ease-in-out",
  },
  label: {
    padding: "6px",
    color: "white",
    fontWeight: "bold",
    fontSize: "12px",
  },
};
